import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
import DiningHall from "../../components/icons/NavIcons/DiningHall";
import Kitchen from "../../components/icons/NavIcons/Kitchen";
import FoodCourt from "../../components/icons/NavIcons/FoodCourt";
import ClassroomsAndLibrary from "../../components/icons/NavIcons/ClassroomsAndLibrary";
import ShippingAndReceiving from "../../components/icons/NavIcons/ShippingAndReceiving";
import BookStore from "../../components/icons/NavIcons/BookStore";
import GiftShop from "../../components/icons/NavIcons/GiftShop";

const MainCampusPage = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    return (
      <div className="page splash2 mainCampusPage">
        <Header />
        <div className="page-header">Main Campus</div>
        <div className="text-blocks">
          <div className="std-text">
            Power your campus with a modern 
            F&B experience through a suite of software 
            solutions for higher education environments 
            that focuses on the diverse preferences of
            your student and faculty population 
            with touch-free transactions.{'\n\n'}

            Automate the food ordering experience and 
            get real-time F&B operational insights.
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "Main Campus", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="main-campus-map">
          <div className="classrooms">
            <ClassroomsAndLibrary
              onClick={() => {
                _logEvent("click", "Main Campus", "Classrooms and Library");
                addFlow("Classrooms And Library");
                navigate("classrooms", { relative: "path" });
              }}
            />
          </div>
          <div className="shipping">
            <ShippingAndReceiving
              onClick={() => {
                _logEvent("click", "Main Campus", "Shipping and Receiving");
                addFlow("Shipping and Receiving");
                navigate("shipping-receiving", { relative: "path" });
              }}
            />
          </div>
          <div className="gift-shop">
            <GiftShop
              onClick={() => {
                _logEvent("click", "Main Campus", "Gift Shop");
                addFlow("Gift Shop");
                navigate("gift-shop", { relative: "path" });
              }}
            />
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
      </div>
    );
}

export default MainCampusPage;